import { useContext } from "react";
import { GlobalContext } from "../../../../Context/GlobalContext";
import { payAccountClick } from "../../../../Layout/Common/common";
import { CardIcon } from "../../../../Layout/Common/CardIcon";

export const BankTransfer = ({ handleOnCheck }) => {
  const { selectedPaymentType } = useContext(GlobalContext);
  return (
    <div className="payment-card-list shipPayment">
      <div className="shipping-method savedCards-details">
        <div className="shipping-method-info pay-option" data-group={1} data-type="bankTransfer" id="pay-account">
          <div>
            <input
              className="form-check-input"
              type="radio"
              name="paymentMethod"
              id="banktransfer"
              value="BT"
              onChange={() => handleOnCheck("BT")}
              checked={selectedPaymentType == "BT"}
            />
          </div>
          <label className="form-check-label" htmlFor="banktransfer">
            <div className="full-width d-flex align-items-center" style={{ gap: "10px", minWidth: "50px" }}>
              <div className="pay-icon">
                <CardIcon cardType={"acc-pay"} />
              </div>
              <div>Bank Transfer</div>
            </div>
          </label>
        </div>
      </div>
    </div>
  );
};
